import { Brand } from "@/data/brands";
import { getScoreColors } from "@/utils/scoreColors";
import { useLanguage } from "@/contexts/LanguageContext";
import { m } from "framer-motion";
import { BeeswarmPosition } from "@/utils/horizonLayout";

interface HorizonTooltipProps {
  brand: Brand;
  position: BeeswarmPosition | undefined;
  onClick?: (brandId: string) => void;
}

const HorizonTooltip = ({ brand, position, onClick }: HorizonTooltipProps) => {
  const { language } = useLanguage();

  if (!position) return null;

  const isRightHalf = position.x > 0.5;
  const bottomPct = Math.max(4, Math.min(position.visualY * 100 + 6, 88));

  return (
    <m.div
      className={`absolute z-[60] bg-card/95 backdrop-blur-md border border-border rounded-2xl shadow-xl p-4 ${onClick ? 'cursor-pointer pointer-events-auto' : 'pointer-events-none'}`}
      onClick={(e) => { e.stopPropagation(); onClick?.(brand.id); }}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.2 }}
      style={{
        left: isRightHalf ? undefined : `${position.x * 100 + 3}%`,
        right: isRightHalf ? `${(1 - position.x) * 100 + 3}%` : undefined,
        bottom: `${bottomPct}%`,
        maxWidth: "220px",
      }}
    >
      <div className="flex items-center gap-3">
        <div
          className="w-11 h-11 rounded-xl flex items-center justify-center text-sm font-bold text-white flex-shrink-0 shadow-sm"
          style={{ backgroundColor: getScoreColors(brand.overallScore).hex }}
        >
          {brand.overallScore}
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-foreground text-sm truncate">{brand.name}</p>
          <p className="text-xs text-muted-foreground truncate">
            {brand.headquarter || brand.category}
          </p>
          <p className="text-[10px] text-primary font-medium mt-1">
            {language === "fr" ? "Cliquez pour le détail →" : "Click for details →"}
          </p>
        </div>
      </div>
    </m.div>
  );
};

export default HorizonTooltip;
